import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiDeleteReminder, apiGetReminderTrashData, apiRecoverReminder } from 'services/ReminderService'

export const getTrashReminders = createAsyncThunk('reminderTrash/data/getTrashReminders',async (data) => {
    const response = await apiGetReminderTrashData(data)
    return response.data
})

export const recoverReminder = async (data) => {
    const response = await apiRecoverReminder(data)
    return response.data
}

export const deleteReminder = async (data) => {
    const response = await apiDeleteReminder(data)
    return response.data
}

export const initialTableData = {
    total: 0,
    pageIndex: 1,
    pageSize: 10,
    query: '',
    sort: {
        order: '',
        key: ''
    }
}

export const initialState = {
    loading: false,
    reminderTrash: [],
    openFeedback: '',
    tableData: initialTableData,
}

const dataSlice = createSlice({
    name: 'reminderTrash/data',
    initialState,
    reducers: {
        reset: () => initialState,
        setTableData: (state, action) => {
            state.tableData = action.payload
        },
    },
    extraReducers: (builder) => {
		builder.addCase(getTrashReminders.fulfilled, (state, action) => {
            state.reminderTrash = action.payload.items
            state.tableData.total = action.payload?.meta?.totalItems
            state.openFeedback = action.payload?.open_feedback
            state.loading = false
        })
        builder.addCase(getTrashReminders.pending, (state) => {
            state.loading = true
        })
    }
})

export const { reset, setTableData, setSortedColumns } = dataSlice.actions

export default dataSlice.reducer
